export default class CalibrationTrackingMethods {
  static TIME = 1;
  static ACTUATION = 2;
  static TIME_AND_ACTUATION = 3;
}
